import parser from 'ua-parser-js';

const state = {
  browser: null,
  cpu: null,
  device: null,
  engine: null,
  os: null,
  ua: '',
};

const getters = {
  // eslint-disable-next-line
  notifyGroupName: s => s.device && s.device.type === 'mobile' ? 'mobile' : 'web',
};

const actions = {
  uaParse({ commit }) {
    const result = parser();
    commit('setParseResult', result);
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  setParseResult(s, result) {
    s.browser = result.browser;
    s.cpu = result.cpu;
    s.device = result.device;
    s.engine = result.engine;
    s.os = result.os;
    s.ua = result.ua;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/ua.js